(() => {
  const SELECTED_LIMIT = 10;
  const SEARCH_DELAY = 250;
  const DEFAULT_SUGGESTION_QUERIES = [
    'cocktail pick',
    'food pick',
    'bamboo',
    'toothpick',
    'straw',
    'napkin',
    'paper',
    'party',
    'drink',
    'gold'
  ];

  const absoluteUrl = (url) => {
    try {
      const parsed = new URL(url, window.location.origin);
      parsed.searchParams.delete('oseid');
      parsed.searchParams.delete('preview_theme_id');
      return parsed.href;
    } catch (_) { return url || ''; }
  };

  const normalizeProduct = (product) => {
    if (!product) return null;
    const rawId = String(product.id || '');
    const id = rawId.includes('/') ? rawId.split('/').pop() : rawId;
    const image = product.featured_image;
    const imageUrl = typeof image === 'string' ? image : image && (image.url || image.src);
    return {
      id,
      title: product.title || '',
      handle: product.handle || '',
      url: product.url || (product.handle ? `/products/${product.handle}` : ''),
      image: imageUrl || ''
    };
  };

  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  }[char]));

  const debounce = (callback, delay) => {
    let timer;
    return (...args) => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => callback(...args), delay);
    };
  };

  document.querySelectorAll('[data-pdp-quote]').forEach((root) => {
    if (root.dataset.pdpQuoteReady === 'true') return;
    root.dataset.pdpQuoteReady = 'true';

    const dialog = root.querySelector('[data-pdp-quote-dialog]');
    const form = root.querySelector('.pdp-quote__form');
    const dataNode = root.querySelector('[data-pdp-quote-data]');
    if (!dialog || !form || !dataNode || typeof dialog.showModal !== 'function') return;

    let data;
    try { data = JSON.parse(dataNode.textContent); } catch (_) { return; }

    const currentProduct = normalizeProduct(data.currentProduct);
    const messages = data.messages || {};
    const variants = Array.isArray(data.variants) ? data.variants : [];
    const views = {
      form: root.querySelector('[data-quote-view="form"]'),
      picker: root.querySelector('[data-quote-view="picker"]'),
      success: root.querySelector('[data-quote-view="success"]')
    };
    const selectedContainer = root.querySelector('[data-selected-products]');
    const interestedInput = root.querySelector('[data-interested-products]');
    const configurationInput = root.querySelector('[data-current-configuration]');
    const variantInput = root.querySelector('[data-current-variant-id]');
    const skuInput = root.querySelector('[data-current-sku]');
    const searchInput = root.querySelector('[data-product-search]');
    const resultContainer = root.querySelector('[data-product-results]');
    const pickerStatus = root.querySelector('[data-picker-status]');
    const submitError = root.querySelector('[data-submit-error]');
    const submitButton = root.querySelector('[data-quote-submit]');
    const submitLabel = root.querySelector('[data-submit-label]');
    const submittingLabel = root.querySelector('[data-submitting-label]');
    const notes = root.querySelector('[data-notes]');
    const notesCount = root.querySelector('[data-notes-count]');
    const confirmed = new Map();
    let draft = new Map();
    let lastTrigger = null;
    let recommendationResults = [];
    let recommendationsLoaded = false;
    let suggestionResults = [];
    let suggestionsLoaded = false;
    let pickerSearchVersion = 0;
    let submittedSuccessfully = false;

    const showView = (name) => {
      Object.entries(views).forEach(([key, element]) => {
        if (element) element.hidden = key !== name;
      });
      dialog.dataset.state = name;
      if (name === 'picker') window.requestAnimationFrame(() => searchInput && searchInput.focus());
      if (name === 'success') window.requestAnimationFrame(() => views.success && views.success.focus());
    };

    const updateInterestedProducts = () => {
      const products = [currentProduct, ...confirmed.values()];
      interestedInput.value = products.map((product) => `${product.title} — ${absoluteUrl(product.url)}`).join('\n');
    };

    const renderSelected = () => {
      selectedContainer.innerHTML = [...confirmed.values()].map((product) => `
        <div class="pdp-quote__selected-item" data-selected-id="${escapeHtml(product.id)}">
          <strong>${escapeHtml(product.title)}</strong>
          <button class="pdp-quote__remove" type="button" data-remove-product="${escapeHtml(product.id)}">${escapeHtml(messages.remove)}</button>
        </div>
      `).join('');
      updateInterestedProducts();
    };

    const setPickerStatus = (message) => { pickerStatus.textContent = message || ''; };

    const renderResults = (products, heading) => {
      const unique = new Map();
      products.map(normalizeProduct).filter(Boolean).forEach((product) => {
        if (product.id && product.id !== currentProduct.id) unique.set(product.id, product);
      });
      const rows = [...unique.values()];
      setPickerStatus(rows.length ? heading : messages.empty);
      resultContainer.innerHTML = rows.map((product) => {
        const checked = draft.has(product.id);
        const image = product.image
          ? `<img src="${escapeHtml(product.image)}" alt="" loading="lazy" width="50" height="50">`
          : '<span class="pdp-quote__result-image" aria-hidden="true"></span>';
        return `
          <label class="pdp-quote__result${checked ? ' is-selected' : ''}" data-result-id="${escapeHtml(product.id)}">
            ${image}
            <span class="pdp-quote__result-title">${escapeHtml(product.title)}</span>
            <input type="checkbox" value="${escapeHtml(product.id)}"${checked ? ' checked' : ''}>
          </label>
        `;
      }).join('');
      rows.forEach((product) => {
        const row = resultContainer.querySelector(`[data-result-id="${CSS.escape(product.id)}"]`);
        if (row) row._quoteProduct = product;
      });
      return rows.length;
    };

    const rootRoute = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const canRenderRecommendations = (requestVersion) => requestVersion === pickerSearchVersion && !searchInput.value.trim();

    const suggestionQueries = () => {
      const start = Math.floor(Math.random() * DEFAULT_SUGGESTION_QUERIES.length);
      return [
        ...DEFAULT_SUGGESTION_QUERIES.slice(start),
        ...DEFAULT_SUGGESTION_QUERIES.slice(0, start)
      ];
    };

    const fetchSearchProducts = async (term, limit = 8) => {
      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'product',
        'resources[limit]': String(limit),
        'resources[options][unavailable_products]': 'show'
      });
      const response = await fetch(`${rootRoute()}search/suggest.json?${params}`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('search');
      const payload = await response.json();
      const products = payload.resources && payload.resources.results && payload.resources.results.products;
      return Array.isArray(products) ? products : [];
    };

    const loadSuggestedProducts = async (requestVersion = pickerSearchVersion) => {
      if (!canRenderRecommendations(requestVersion)) return;
      if (suggestionsLoaded) {
        if (canRenderRecommendations(requestVersion)) renderResults(suggestionResults, messages.recommended);
        return;
      }
      setPickerStatus(messages.loading);
      try {
        let products = [];
        for (const term of suggestionQueries().slice(0, 4)) {
          products = await fetchSearchProducts(term);
          if (!canRenderRecommendations(requestVersion)) return;
          if (products.some((product) => {
            const normalized = normalizeProduct(product);
            return normalized && normalized.id !== currentProduct.id;
          })) break;
        }
        if (!canRenderRecommendations(requestVersion)) return;
        suggestionResults = products;
        suggestionsLoaded = true;
        renderResults(suggestionResults, messages.recommended);
      } catch (_) {
        if (!canRenderRecommendations(requestVersion)) return;
        setPickerStatus(messages.searchHint || messages.empty);
        resultContainer.innerHTML = '';
      }
    };

    const loadRecommendations = async () => {
      const requestVersion = pickerSearchVersion;
      if (!canRenderRecommendations(requestVersion)) return;
      if (recommendationsLoaded) {
        if (recommendationResults.length > 0) {
          const renderedCount = renderResults(recommendationResults, messages.recommended);
          if (renderedCount === 0) loadSuggestedProducts(requestVersion);
        } else {
          loadSuggestedProducts(requestVersion);
        }
        return;
      }
      setPickerStatus(messages.loading);
      try {
        const url = `${rootRoute()}recommendations/products.json?product_id=${encodeURIComponent(currentProduct.id)}&limit=8&intent=complementary`;
        const response = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('recommendations');
        const payload = await response.json();
        if (!canRenderRecommendations(requestVersion)) return;
        recommendationResults = Array.isArray(payload.products) ? payload.products : [];
        recommendationsLoaded = true;
        if (recommendationResults.length > 0) {
          const renderedCount = renderResults(recommendationResults, messages.recommended);
          if (renderedCount === 0) loadSuggestedProducts(requestVersion);
        } else {
          loadSuggestedProducts(requestVersion);
        }
      } catch (_) {
        if (canRenderRecommendations(requestVersion)) loadSuggestedProducts(requestVersion);
      }
    };

    const searchProducts = debounce(async () => {
      const requestVersion = pickerSearchVersion;
      const term = searchInput.value.trim();
      if (term.length < 2) {
        if (term.length === 0) loadRecommendations();
        else {
          setPickerStatus(messages.searchHint);
          resultContainer.innerHTML = '';
        }
        return;
      }
      setPickerStatus(messages.loading);
      try {
        const products = await fetchSearchProducts(term, 10);
        if (requestVersion !== pickerSearchVersion || searchInput.value.trim() !== term) return;
        renderResults(products, messages.searchResults);
      } catch (_) {
        if (requestVersion !== pickerSearchVersion || searchInput.value.trim() !== term) return;
        setPickerStatus(messages.loadError);
        resultContainer.innerHTML = '';
      }
    }, SEARCH_DELAY);

    const openPicker = () => {
      pickerSearchVersion += 1;
      draft = new Map(confirmed);
      searchInput.value = '';
      showView('picker');
      loadRecommendations();
    };

    const closePicker = () => {
      pickerSearchVersion += 1;
      draft = new Map(confirmed);
      showView('form');
      const button = root.querySelector('[data-open-product-picker]');
      if (button) button.focus();
    };

    const syncConfiguration = () => {
      const productArea = root.closest('.product__info-container') || document;
      const productForm = productArea.querySelector('form[action*="/cart/add"]');
      const selectedVariantId = productForm && productForm.querySelector('[name="id"]') && productForm.querySelector('[name="id"]').value;
      if (selectedVariantId) {
        variantInput.value = selectedVariantId;
        const variant = variants.find((item) => String(item.id) === String(selectedVariantId));
        skuInput.value = variant && variant.sku ? variant.sku : '';
      }

      const wanted = ['Material', 'Pack size', 'Order path'];
      const values = [];
      wanted.forEach((label) => {
        const escaped = CSS.escape(label);
        const candidates = productArea.querySelectorAll(
          `[name="properties[${escaped}]"]:checked, select[name="properties[${escaped}]"] option:checked, [data-option-name="${escaped}"] input:checked`
        );
        const value = [...candidates].map((node) => node.value || node.textContent.trim()).find(Boolean);
        if (value) values.push(`${label}: ${value}`);
      });
      if (productForm) {
        const quantity = productForm.querySelector('[name="quantity"]');
        if (quantity && quantity.value) values.push(`Quantity: ${quantity.value}`);
      }
      configurationInput.value = values.join('\n');
    };

    const clearFieldErrors = () => {
      form.querySelectorAll('[aria-invalid="true"]').forEach((field) => field.removeAttribute('aria-invalid'));
      form.querySelectorAll('[data-field-error]').forEach((error) => { error.textContent = ''; });
    };

    const validateForm = () => {
      clearFieldErrors();
      const invalid = [];
      form.querySelectorAll('input[required]').forEach((field) => {
        let message = '';
        if (!field.value.trim()) message = messages.required;
        else if (field.type === 'email' && !field.validity.valid) message = messages.email;
        if (message) {
          field.setAttribute('aria-invalid', 'true');
          const error = field.parentElement.querySelector('[data-field-error]');
          if (error) error.textContent = message;
          invalid.push(field);
        }
      });
      if (invalid.length) invalid[0].focus();
      return invalid.length === 0;
    };

    const setSubmitting = (submitting) => {
      submitButton.disabled = submitting;
      submitLabel.hidden = submitting;
      submittingLabel.hidden = !submitting;
      form.setAttribute('aria-busy', String(submitting));
    };

    const showSubmitError = (message) => {
      submitError.textContent = message || messages.submitError;
      submitError.hidden = false;
      submitError.focus && submitError.focus();
    };

    const resetAfterSuccess = () => {
      form.reset();
      confirmed.clear();
      draft.clear();
      renderSelected();
      clearFieldErrors();
      submitError.hidden = true;
      submitError.textContent = '';
      if (notesCount) notesCount.textContent = '0';
      submittedSuccessfully = false;
      showView('form');
      const url = new URL(window.location.href);
      if (url.searchParams.has('quote_submitted')) {
        url.searchParams.delete('quote_submitted');
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      }
    };

    root.querySelectorAll('[data-pdp-quote-open]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        lastTrigger = trigger;
        showView('form');
        dialog.showModal();
        document.body.classList.add('pdp-quote-open');
        window.requestAnimationFrame(() => root.querySelector('input[required]')?.focus());
      });
    });

    root.querySelectorAll('[data-pdp-quote-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
    root.querySelectorAll('[data-success-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
    root.querySelector('[data-open-product-picker]')?.addEventListener('click', openPicker);
    root.querySelectorAll('[data-picker-back]').forEach((button) => button.addEventListener('click', closePicker));
    searchInput?.addEventListener('input', () => {
      pickerSearchVersion += 1;
      searchProducts();
    });
    notes?.addEventListener('input', () => { notesCount.textContent = String(notes.value.length); });

    selectedContainer.addEventListener('click', (event) => {
      const button = event.target.closest('[data-remove-product]');
      if (!button) return;
      confirmed.delete(button.dataset.removeProduct);
      renderSelected();
    });

    resultContainer.addEventListener('change', (event) => {
      const checkbox = event.target.closest('input[type="checkbox"]');
      const row = event.target.closest('[data-result-id]');
      if (!checkbox || !row || !row._quoteProduct) return;
      if (checkbox.checked) {
        if (draft.size + 1 >= SELECTED_LIMIT) {
          checkbox.checked = false;
          setPickerStatus(messages.limit);
          return;
        }
        draft.set(row._quoteProduct.id, row._quoteProduct);
      } else {
        draft.delete(row._quoteProduct.id);
      }
      row.classList.toggle('is-selected', checkbox.checked);
    });

    root.querySelector('[data-add-selected]')?.addEventListener('click', () => {
      confirmed.clear();
      draft.forEach((product, id) => confirmed.set(id, product));
      renderSelected();
      showView('form');
      root.querySelector('[data-open-product-picker]')?.focus();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('pdp-quote-open');
      if (submittedSuccessfully) resetAfterSuccess();
      if (lastTrigger) lastTrigger.focus();
    });

    form.addEventListener('submit', (event) => {
      submitError.hidden = true;
      if (!validateForm()) {
        event.preventDefault();
        return;
      }
      syncConfiguration();
      updateInterestedProducts();
      setSubmitting(true);
    });

    form.addEventListener('input', (event) => {
      const field = event.target.closest('input[required]');
      if (!field || field.getAttribute('aria-invalid') !== 'true') return;
      const valid = field.value.trim() && (field.type !== 'email' || field.validity.valid);
      if (!valid) return;
      field.removeAttribute('aria-invalid');
      const error = field.parentElement.querySelector('[data-field-error]');
      if (error) error.textContent = '';
    });

    renderSelected();

    if (new URLSearchParams(window.location.search).get('quote_submitted') === '1') {
      submittedSuccessfully = true;
      lastTrigger = root.querySelector('[data-pdp-quote-open]');
      dialog.showModal();
      document.body.classList.add('pdp-quote-open');
      showView('success');
    }
  });
})();
